export default "__VITE_ASSET__1NNaBFCW__"